package org.ecolution.webpage.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*

@Page
@Composable
fun KoenigswegPage() {
    org.ecolution.webpage.components.layouts.MarkdownLayout("Mitgliedschaft & Königsweg") {
        org.ecolution.webpage.components.widgets.EcoSpacer()
        org.jetbrains.compose.web.dom.H3(attrs = { id("wir-sind-mitglied-bei-gebäudehülle-schweiz-sektion-aargau") }) {
            org.jetbrains.compose.web.dom.Text("Wir sind Mitglied bei Gebäudehülle Schweiz – Sektion Aargau")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Seit dem 1. Januar 2025 ist Ecolution Engineering offizielles Mitglied im Netzwerk von Gebäudehülle Schweiz, Sektion Aargau. 🔗 ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://gebäudehülle.swiss/ecolution-engineering-gmbh", "Zum Mitgliederprofil")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Was bedeutet das für Sie?")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("✅ Mehr Know‑how rund um Dämmung, Fenster, Dach & Fassade")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("✅ Zugang zu bewährten Lösungen & Partnern")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("✅ Komplettsanierungen aus einer Hand")
        }
        org.jetbrains.compose.web.dom.H4(attrs = { id("der-königsweg-e-in-3-etappen-zur-energieeffizienz") }) {
            org.jetbrains.compose.web.dom.Text("Der Königsweg E+: In 3 Etappen zur Energieeffizienz")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Mit dem Königsweg E+ modernisieren Sie Ihr Gebäude schrittweise – mit messbarem Effekt: bis zu 81 % Energieersparnis! 📽️ ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://www.youtube.com/watch?v=LHRMBDgWUzw&t=48s", "Video: So funktioniert der Königsweg E+")
        }
        org.jetbrains.compose.web.dom.H5(attrs = { id("etappe-1-gebäudehülle") }) {
            org.jetbrains.compose.web.dom.Text("🧱 Etappe 1: Gebäudehülle")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dach- & Fassadendämmung")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Fenster ersetzen")
            }
        }
        org.jetbrains.compose.web.dom.H5(attrs = { id("etappe-2-haustechnik") }) {
            org.jetbrains.compose.web.dom.Text("🔧 Etappe 2: Haustechnik")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Wärmepumpe installieren")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Solarthermie nutzen")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Warmwasser-Boiler optimieren")
            }
        }
        org.jetbrains.compose.web.dom.H5(attrs = { id("etappe-3-eigenstrom") }) {
            org.jetbrains.compose.web.dom.Text("☀️ Etappe 3: Eigenstrom")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Photovoltaik aufs Dach")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Batteriespeicher integrieren")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Smart-Home-Technik einbinden")
            }
        }
        org.jetbrains.compose.web.dom.H4(attrs = { id("nächste-schritte-mit-ecolution") }) {
            org.jetbrains.compose.web.dom.Text("Nächste Schritte mit Ecolution")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Em {
                    org.jetbrains.compose.web.dom.Text("GEAK Plus & Massnahmenplan")
                }
                org.jetbrains.compose.web.dom.Text(" – Analyse, Fördermittel-Check und sinnvolle Etappierung")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Em {
                    org.jetbrains.compose.web.dom.Text("Umsetzung mit Qualitätsgarantie")
                }
                org.jetbrains.compose.web.dom.Text(" – Über unser Netzwerk geprüfter Gebäudehüllen-Partner")
            }
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("🔍 Jetzt GEAK Plus sichern")
            }
            org.jetbrains.compose.web.dom.Text(" – und den Königsweg gemeinsam mit uns gehen!")
        }
        org.ecolution.webpage.components.widgets.BlogIntro(6)
        org.ecolution.webpage.components.widgets.EcoSpacer()
    }
}
